const Actions = {
  FETCH_ALL_USER_ACTIVITY: "FETCH_ALL_USER_ACTIVITY",
  FETCH_ALL_USER_ACTIVITY_SUCCESS: "FETCH_ALL_USER_ACTIVITY_SUCCESS",
  FETCH_ALL_USER_ACTIVITY_FAILURE: "FETCH_ALL_USER_ACTIVITY_FAILURE",
};

export default Actions;
